define(['backbone', './Item'], function (Backbone, SurveyItemModel) {
  var ItemCollection = Backbone.Collection.extend({ model: SurveyItemModel })

  return Backbone.Model.extend({
    urlRoot: '/survey',

    defaults: {
      id: null,
      items: ItemCollection
    },

    initializeItems: function (items) {
      this.set('items', new ItemCollection(items))
    },

    parse: function (res) {
      if (res.survey.items) { res.survey.items = new ItemCollection(res.survey.items) }
      return res.survey || {}
    },

    initialize: function (data) {
      this.initializeItems(data.items || [])
    }
  })
})
